/**
 * Default dashboard content: full Dashboard for ops roles; technician home for TECHNICIAN.
 */
import React from 'react';
import DashboardPage from './DashboardPage';
import TechnicianHomePage from './TechnicianHomePage';
import { isTechnician } from '../utils/accessControl';

export default function DefaultDashboardContent() {
  if (isTechnician()) {
    return <TechnicianHomePage />;
  }
  return <DashboardPage />;
}
